<div class="round-container"
     (click)="onClicked.emit()">
    <div class="background-colors">
        <ng-container *ngFor="let backgroundColor of backgroundColors">
            <div *ngIf="backgroundColor"
                 class="background-color-item"
                 [style.background-color]="backgroundColor">
            </div>
        </ng-container>
    </div>
    <div>
        <span>{{ mainMetricValue }}</span>
        <span *ngIf="mainMetricValue" class="legend">{{ mainMetricUnit }}</span>
    </div>
</div>
<div class="metrics-container"
     (click)="onClicked.emit()">
    <div class="title">
        {{ title }}
    </div>
    <div class="legend">
        {{ legend }}
    </div>
</div>
